import AccruentLogo from "./AccruentLogo.png";

// This object should contain only images required
// by the entire application, there should not be
// any product-specific images here.
export const images = {
    "AccruentLogo.png": AccruentLogo
}